import http from '@/services/http'
import { useAppStore } from '@/stores/AppStore'
import { CreateReviewDTO } from '@/type/Feedback'

export function useFeedbackRepository(clinic_uuid: string) {
  const appStore = useAppStore()

  function fetchOPDReview(opd_uuid: string) {
    return http.get(
      `${appStore.url}/api/v1/crm/line-app/p/feedback/?opd_uuid=${opd_uuid}&clinic_uuid=${clinic_uuid}&line_user_id=${appStore.userProfile.userId}&liffId=${appStore.liffId}`,
    )
  }

  function createOPDReview(opd_uuid: string, review_data: CreateReviewDTO[]) {
    return http.post(
      `${appStore.url}/api/v1/crm/line-app/p/feedback/?opd_uuid=${opd_uuid}&clinic_uuid=${clinic_uuid}&line_user_id=${appStore.userProfile.userId}&liffId=${appStore.liffId}`,
      review_data,
    )
  }

  return {
    fetchOPDReview,
    createOPDReview,
  }
}
